<template>
    <div class="container">
        <h2>Visualizando Documento: {{ name }}</h2>
        <iframe v-if="fileUrl" :src="fileUrl" width="100%" height="600px"></iframe>
        <p v-else>Carregando documento...</p>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            name: this.$route.params.name,
            id: "",
            fileUrl: ""
        };
    },
    created() {
        if (this.$root.user) {
            this.user = this.$root.user
        }

        const id = this.$route.query.id;

        this.loadTerm(id);
    },

    methods: {
        async loadTerm(id) {

            const profileType = this.user.profile === 1 ? 'users' : 'lawyers'

            try {
                const response = await axios.get(`/api/${profileType}/policies/${id}`);

                this.fileUrl = response.data.content.s3_url

                this.$router.replace({ path: `/arquivo/${this.name}` });
            } catch (error) {
                console.error('Erro ao buscar políticas:', error);
            }
        },
    }
};
</script>

<style scoped>
.container {
    text-align: center;
    margin-top: 20px;
}
</style>